import styles from '@/components/Card/components/CompaniesToDiscover/styles.less';
import Avatars from '@/components/Avatars';
import classnames from 'classnames';
import React from 'react';
import { useFormatMessage } from 'react-intl-hooks';

export const CompaniesToDiscover = ({ event, context }) => {
  const t = useFormatMessage();

  return (
    <div className={styles.discoverBusinesses}>
      <a className={styles.numberOfRecruiter}>
        {t({ id: 'events.explore.companyDiscover' }, { count: event.countExponents })}
      </a>
      <Avatars
        className={styles.avatarsContainer}
        cssPictureItem={classnames(styles.avatars, context === 'onboarding' ? styles.onboardingAvatars : '')}
        pictures={event.exponentsPicture}
        maxPictures={3}
      />
    </div>
  )
}
